import { render, staticRenderFns } from "./PoolsAdmin.vue?vue&type=template&id=4e9a6b38"
import script from "./PoolsAdmin.vue?vue&type=script&lang=ts"
export * from "./PoolsAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports